import { CheckboxController } from '@components/react-hook-components'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import type { Control, FieldValues, Path } from 'react-hook-form'

type BooleanFeatureValueInputProps<T extends FieldValues> = {
  control: Control<T>
  name: Path<T>
}

export const BooleanFeatureValueInput = <T extends FieldValues>({ control, name }: BooleanFeatureValueInputProps<T>) => {
  return (
    <Stack direction="row" alignItems="center" spacing="16px">
      <CheckboxController control={control} name={name} />
      <Typography variant="body2">Value</Typography>
    </Stack>
  )
}
